<template>
    <properties-component v-bind="$props" @close="$emit('close')">
        <b-form-group>
            <template #label>
                <btn-responsive-prop v-model="component" field="type"/>
            </template>
            <b-select v-model="component.mediaProxy.type">
                <option value="none" v-tr>Default|Défaut</option>
                <option value="image" v-tr>Image</option>
                <option value="color" v-tr>Color|Couleur</option>
            </b-select>
        </b-form-group>

        <b-form-group v-if="component.mediaProxy.type === 'image'">
            <input-image v-model="component.image"/>
        </b-form-group>

        <b-form-group v-else-if="component.type === 'color'">
            <input-color v-model="component.color" allow-transparent button block :label="'Custom Color|Couleur personnalisée'"/>
        </b-form-group>

        <b-form-group>
            <input-border-radius v-model="component.radius">
                <template #prepend>
                    <btn-responsive-prop v-model="component" field="radius" no-label/>
                </template>
            </input-border-radius>
        </b-form-group>

        <slot></slot>
    </properties-component>
</template>

<script>
import BtnResponsiveProp from "@/components/editor/properties/components/btn-responsive-prop.vue";
import PropertiesComponent from "@/components/editor/properties/components/properties-component.vue";
import InputColor from "@/components/editor/properties/inputs/input-color.vue";
import EInput from "../../../../../vue-components/components/e-input.vue";
import InputImage from "@components/editor/properties/inputs/input-image.vue";
import InputBorderRadius from "@components/editor/properties/inputs/input-border-radius.vue";

// properties-component-background #hot-reload-debug
export default {
    name: `properties-component-background`,
    components: {InputBorderRadius, InputImage, EInput, BtnResponsiveProp, InputColor, PropertiesComponent},
    extends: PropertiesComponent
}
</script>

<style lang="scss" scoped>
</style>
